// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global colors */
:root {
  /* Grayscale */
  --color-grayscale-0: white;
  --color-grayscale-1: #fafafa;
  --color-grayscale-2: #e9ecef;
  --color-grayscale-3: #dee2e6;
  --color-grayscale-4: #ced4da;
  --color-grayscale-5: #adb5bd;
  --color-grayscale-6: #6c757d;
  --color-grayscale-7: #495057;
  --color-grayscale-8: #343a40;
  --color-grayscale-9: #212529;
  --color-grayscale-10: black;

  /* Primary */
  --color-primary-0: #eee;
  --color-primary-1: #d8d8d8;
  --color-primary-2: #b5b5b5;
  --color-primary-3: #929292;
  --color-primary-4: #696969;
  --color-primary-6: #565656;
  --color-primary-8: #363636;
  --color-primary-9: #2B2B2B;
  --color-primary-10: black;

  /* Blue */
  --color-blue-0: #d2edfe;
  --color-blue-4: #1c9ae8;
  --color-blue-6: #0678bf;
  --color-blue-8: #1071ad;
  --color-blue-9: #0c5078;
  --color-blue-10: #053c5c;

  /* Orange */
  --color-orange-0: #FFDAC2;
  --color-orange-4: #FFB685;
  --color-orange-6: #FF9147;
  --color-orange-8: #f60;
  --color-orange-9: #cc5200 ;
  --color-orange-10: #A34100;

  /* Green */
  --color-green-0: #ebffeb;
  --color-green-4: #aae3aa;
  --color-green-6: #8dc98d;
  --color-green-8: #41a741;
  --color-green-9: #328032;
  --color-green-10: #136613;
}
/* Button */
:root {
  /* Primary */
  --btn-color-primary-0: var(--color-green-8);

  /* Secondary */
  --btn-color-secondary-0: var(--color-primary-6);
}
.theme-blue {
  /* Button */
  --btn-color-primary-0: var(--color-blue-8);
  --color-primary-0: var(--color-blue-0);
  --color-primary-4: var(--color-blue-4);
  --color-primary-6: var(--color-blue-6);
  --color-primary-8: var(--color-blue-8);
  --color-primary-9: var(--color-blue-9);
  --color-primary-10: var(--color-blue-10);
}
.theme-orange {
  /* Button */
  --btn-color-primary-0: var(--color-orange-8);
  --color-primary-0: var(--color-orange-0);
  --color-primary-4: var(--color-orange-4);
  --color-primary-6: var(--color-orange-6);
  --color-primary-8: var(--color-orange-8);
  --color-primary-9: var(--color-orange-9);
  --color-primary-10: var(--color-orange-10);
}
.theme-green {
  /* Button */
  --btn-color-primary-0: var(--color-green-8);
  --color-primary-0: var(--color-green-0);
  --color-primary-4: var(--color-green-4);
  --color-primary-6: var(--color-green-6);
  --color-primary-8: var(--color-green-8);
  --color-primary-9: var(--color-green-9);
  --color-primary-10: var(--color-green-10);
}
/* iPhone X+ */
:root {
  --safe-area-inset-top: env(safe-area-inset-top);
  --safe-area-inset-right: env(safe-area-inset-right);
  --safe-area-inset-bottom: env(safe-area-inset-bottom);
  --safe-area-inset-left: env(safe-area-inset-left);
}
/* Evelevations */
:root {
  --elevation-drawer: 100;
  --elevation-app-bar: 1000;
  --elevation-modal: 7000;
  --elevation-global-loading: 8000;
  --elevation-toast: 9000;
}
*,
*::after,
*::before,
::after,
::before {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./app/components/deprecatedTookit/styles/variables.css","webpack://./app/components/deprecatedTookit/styles/globals.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,cAAc;EACd,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;;EAE3B,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;;EAEzB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;;EAE1B,UAAU;EACV,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;AAC3B;AAEA,WAAW;AACX;EACE,YAAY;EACZ,2CAA2C;;EAE3C,cAAc;EACd,+CAA+C;AACjD;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,wCAAwC;AAC1C;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;AAC5C;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,yCAAyC;AAC3C;AAEA,cAAc;AACd;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,qDAAqD;EACrD,iDAAiD;AACnD;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;AACzB;AC5GA;;;;;EAKE,sBAAsB;AACxB","sourcesContent":["/* Global colors */\n:root {\n  /* Grayscale */\n  --color-grayscale-0: white;\n  --color-grayscale-1: #fafafa;\n  --color-grayscale-2: #e9ecef;\n  --color-grayscale-3: #dee2e6;\n  --color-grayscale-4: #ced4da;\n  --color-grayscale-5: #adb5bd;\n  --color-grayscale-6: #6c757d;\n  --color-grayscale-7: #495057;\n  --color-grayscale-8: #343a40;\n  --color-grayscale-9: #212529;\n  --color-grayscale-10: black;\n\n  /* Primary */\n  --color-primary-0: #eee;\n  --color-primary-1: #d8d8d8;\n  --color-primary-2: #b5b5b5;\n  --color-primary-3: #929292;\n  --color-primary-4: #696969;\n  --color-primary-6: #565656;\n  --color-primary-8: #363636;\n  --color-primary-9: #2B2B2B;\n  --color-primary-10: black;\n\n  /* Blue */\n  --color-blue-0: #d2edfe;\n  --color-blue-4: #1c9ae8;\n  --color-blue-6: #0678bf;\n  --color-blue-8: #1071ad;\n  --color-blue-9: #0c5078;\n  --color-blue-10: #053c5c;\n\n  /* Orange */\n  --color-orange-0: #FFDAC2;\n  --color-orange-4: #FFB685;\n  --color-orange-6: #FF9147;\n  --color-orange-8: #f60;\n  --color-orange-9: #cc5200 ;\n  --color-orange-10: #A34100;\n\n  /* Green */\n  --color-green-0: #ebffeb;\n  --color-green-4: #aae3aa;\n  --color-green-6: #8dc98d;\n  --color-green-8: #41a741;\n  --color-green-9: #328032;\n  --color-green-10: #136613;\n}\n\n/* Button */\n:root {\n  /* Primary */\n  --btn-color-primary-0: var(--color-green-8);\n\n  /* Secondary */\n  --btn-color-secondary-0: var(--color-primary-6);\n}\n\n.theme-blue {\n  /* Button */\n  --btn-color-primary-0: var(--color-blue-8);\n  --color-primary-0: var(--color-blue-0);\n  --color-primary-4: var(--color-blue-4);\n  --color-primary-6: var(--color-blue-6);\n  --color-primary-8: var(--color-blue-8);\n  --color-primary-9: var(--color-blue-9);\n  --color-primary-10: var(--color-blue-10);\n}\n\n.theme-orange {\n  /* Button */\n  --btn-color-primary-0: var(--color-orange-8);\n  --color-primary-0: var(--color-orange-0);\n  --color-primary-4: var(--color-orange-4);\n  --color-primary-6: var(--color-orange-6);\n  --color-primary-8: var(--color-orange-8);\n  --color-primary-9: var(--color-orange-9);\n  --color-primary-10: var(--color-orange-10);\n}\n\n.theme-green {\n  /* Button */\n  --btn-color-primary-0: var(--color-green-8);\n  --color-primary-0: var(--color-green-0);\n  --color-primary-4: var(--color-green-4);\n  --color-primary-6: var(--color-green-6);\n  --color-primary-8: var(--color-green-8);\n  --color-primary-9: var(--color-green-9);\n  --color-primary-10: var(--color-green-10);\n}\n\n/* iPhone X+ */\n:root {\n  --safe-area-inset-top: env(safe-area-inset-top);\n  --safe-area-inset-right: env(safe-area-inset-right);\n  --safe-area-inset-bottom: env(safe-area-inset-bottom);\n  --safe-area-inset-left: env(safe-area-inset-left);\n}\n\n/* Evelevations */\n:root {\n  --elevation-drawer: 100;\n  --elevation-app-bar: 1000;\n  --elevation-modal: 7000;\n  --elevation-global-loading: 8000;\n  --elevation-toast: 9000;\n}","*,\n*::after,\n*::before,\n::after,\n::before {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
